exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myUniverse_buttonGroup {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between; }\n  .myUniverse_buttonGroup button {\n    cursor: pointer; }\n  .myUniverse_buttonGroup .mr5 {\n    margin-right: 5px; }\n  .myUniverse_buttonGroup .btn {\n    line-height: 1.44;\n    border: 1px solid #545a87;\n    border-radius: 20px !important;\n    background-color: #ffffff;\n    font-weight: 600;\n    letter-spacing: 2px;\n    display: inline-table;\n    text-transform: uppercase;\n    padding: 6px 12px;\n    font-size: smaller; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/MyUniverse/buttonGroup/ButtonGroup.style.scss
// module id = 1580
// module chunks = 0